<template>
  <div>
    <!-- Start: Header -->
    <section class="section-header-info">
      <div class="container">
        <div class="row">
          <div class="col-sm-12">
            <nav aria-label="breadcrumb">
              <ol class="breadcrumb">
                <li class="breadcrumb-item">
                  <a href="javascript:void(0)">Onboarding</a>
                </li>
                <li class="breadcrumb-item active" aria-current="page">Candidate</li>
              </ol>
            </nav>
            <div class="content-header-info">
              <div class="col-sm-12">
                <div class="pull-left">
                  <h2>
                    Provider Candidate <span><i class="ic-manage-access"></i></span>
                  </h2>
                  <p>Manage your provider, driver and vehicle candidate.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- End: Header -->

    <!-- Start: Table -->
    <section class="middle-content">
      <div class="container">
        <div class="row" v-if="isAllowToRead">
          <div class="col-sm-6">
            <div class="form-group">
              <div class="btn-group mb-15" role="group" aria-label="...">
                <button
                  type="button"
                  class="btn btn-default"
                  :class="{ 'btn-active': candidateStatus === 'requested' }"
                  @click="getAll('requested')"
                >
                  Requested
                </button>
                <button
                  type="button"
                  class="btn btn-default"
                  :class="{ 'btn-active': candidateStatus === 'approved' }"
                  @click="getAll('approved')"
                >
                  Approved
                </button>
                <button
                  type="button"
                  class="btn btn-default"
                  :class="{ 'btn-active': candidateStatus === 'rejected' }"
                  @click="getAll('rejected')"
                >
                  Rejected
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-6">
            <div class="dataTables_filter">
              <i class="ic-search"></i>
              <input
                type="search"
                class="form-control"
                v-model="table.keyword"
                @keyup="onKeyupKeyword()"
                placeholder="Search, City, Provider or Owner Name"
              />
            </div>
          </div>
          <div class="col-sm-6">
            <div class="dataTables_length pull-right">
              <label>
                <select
                  class="form-control v-select"
                  v-model="table.pageSize"
                  @change="onChangePageSize()"
                >
                  <option v-for="item in table.pageSizes" :value="item" :key="item">
                    {{ item }}
                  </option>
                </select>
                Entries</label
              >
            </div>
          </div>
        </div>
        <div class="row">
          <div class="table-responsive table-p15">
            <table class="table table-hover table-fix">
              <thead>
                <tr>
                  <th>Submitted Date</th>
                  <th v-if="candidateStatus === 'approved'">Approved Date</th>
                  <th v-if="candidateStatus === 'rejected'">Rejected Date</th>
                  <th>Name</th>
                  <th>Email</th>
                  <th>City</th>
                  <th v-if="candidateStatus === 'approved'">Email Sent?</th>
                  <th class="text-center">Action</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in items" :key="item.providerCandidateId">
                  <td>
                    {{ displayDatetime(item.createdDate) }}
                  </td>
                  <td v-if="candidateStatus === 'approved'">
                    {{ displayDatetime(item.approvedDate) }}
                  </td>
                  <td v-if="candidateStatus === 'rejected'">
                    {{ displayDatetime(item.rejectedDate) }}
                  </td>
                  <td>{{ item.name }}</td>
                  <td>{{ item.email }}</td>
                  <td>{{ item.city }}</td>
                  <td v-if="candidateStatus === 'approved'">
                    {{ item.isEmailSent ? "Yes" : "No" }}
                  </td>
                  <td class="text-center">
                    <div class="button-action-wrapper">
                      <button
                        v-if="candidateStatus === 'approved'"
                        class="btn btn-default"
                        type="button"
                        @click="resendEmail(item.providerCandidateId)"
                      >
                        <span>Email</span>
                      </button>
                      <button
                        class="btn btn-default"
                        type="button"
                        @click="viewDetail(item)"
                      >
                        <span>View</span>
                      </button>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-5">
            <div class="dataTables_info --blue25">
              <strong>{{ recordInfo }}</strong>
            </div>
          </div>
          <div class="col-sm-7">
            <nav aria-label="...">
              <paginate
                v-model="table.pageNumber"
                :page-count="table.totalPages"
                :click-handler="onNavigateCallback"
                :prev-text="'Previous'"
                :next-text="'Next'"
                :container-class="'pagination pull-right'"
              >
              </paginate>
            </nav>
          </div>
        </div>
      </div>
    </section>
    <!-- End: Table -->

    <!-- Start: Modal -->
    <div>
      <providerCandidateDetailComponent></providerCandidateDetailComponent>
    </div>
    <!-- End: Modal -->

    <!-- Start: BlockUI -->
    <loader :content="msg" :visible="isLoading" />
    <!-- End: BlockUI -->
  </div>
</template>

<script>
import providerCandidateDetailComponent from "@/components/master/onboarding/ProviderCandidateDetail";
import onBoardingService from "@/services/master/onboarding/onBoardingService.js";
import vehicleService from "@/services/master/vehicle/vehicleService.js";

export default {
  components: {
    providerCandidateDetailComponent,
  },
  computed: {
    isAllowToRead: function () {
      return this.allPermissions.includes("Read");
    },
    isAllowToCreate: function () {
      return this.allPermissions.includes("Create");
    },
    isAllowToUpdate: function () {
      return this.allPermissions.includes("Update");
    },
    isAllowToDelete: function () {
      return this.allPermissions.includes("Delete");
    },
    recordInfo: function () {
      return this.table.totalRecords > 1
        ? `${this.table.totalRecords} Records`
        : `${this.table.totalRecords} Record`;
    },
    userLabel: function () {
      switch (this.candidateStatus) {
        case "requested":
          return "Requested By";
        case "approved":
          return "Approved By";
        case "rejected":
          return "Rejected By";
        default:
          return null;
      }
    },
    dateLabel: function () {
      switch (this.candidateStatus) {
        case "requested":
          return "Requested Date";
        case "approved":
          return "Approved Date";
        case "rejected":
          return "Rejected Date";
        default:
          return null;
      }
    },
  },
  data() {
    return {
      table: {
        keyword: "",
        totalPages: 1,
        totalRecords: 0,
        pageNumber: 1,
        pageSize: 25,
        pageSizes: [25, 50, 100],
      },
      vehicleTypes: [],
      vehicleTransmissions: [],
      vehicleOperations: [],
      vehicleColors: [],
      allPermissions: [],
      candidateStatus: "requested",
      itemToBeDeleted: null,
      items: [],
      model: {},
      isLoading: false,
      msg: "Please wait",
    };
  },
  async created() {
    this.$helper.scrollTop();
    const publicSettings = await this.$store.dispatch("setting/getAllPublic");
    this.table.pageSize = this.$helper.extractSetting(publicSettings, "PageSize", 25);

    // subscribe message
    this.$eventBus.$on("initializeProviderCandidate", this.getAllRequested);

    const profile = await this.$store.dispatch("user/getProfile");
    const permissions = profile.services[this.$route.name];
    if (permissions) {
      this.allPermissions = permissions;
    }

    if (this.isAllowToRead) {
      await this.getAll(this.candidateStatus);
      this.getVehicleCommon();
    }
  },
  updated() {
    this.$helper.collapseMenu("onboarding");
    this.$helper.setNavigationClass("provider-candidate-link");
  },
  beforeDestroy() {
    this.$eventBus.$off("initializeProviderCandidate");
  },
  methods: {
    async onChangePageSize() {
      this.table.pageNumber = 1;
      await this.getAll(this.candidateStatus);
    },
    async onKeyupKeyword() {
      const self = this;
      if (self.timer) {
        clearTimeout(self.timer);
        self.timer = null;
      }
      self.timer = setTimeout(async (_) => {
        self.table.pageNumber = 1;
        await self.getAll(self.candidateStatus);
      }, 500);
    },
    async onNavigateCallback(pageNumber) {
      this.table.pageNumber = pageNumber;
      await this.getAll(this.candidateStatus);
    },
    resetTable() {
      this.table.keyword = "";
      this.table.pageNumber = 1;
      this.table.pageSize = 5;
    },
    resetModel() {
      this.model = {};
    },
    printUserAudit(item) {
      switch (this.candidateStatus) {
        case "requested":
          return item.requestedBy;
        case "approved":
          return item.approvedBy;
        case "rejected":
          return item.rejectedBy;
        default:
          return null;
      }
    },
    printDateAudit(item) {
      switch (this.candidateStatus) {
        case "requested":
          return this.printDate(item.requestedDate);
        case "approved":
          return this.printDate(item.approvedDate);
        case "rejected":
          return this.printDate(item.rejectedDate);
        default:
          return null;
      }
    },
    printDate(item) {
      return `${item.year}-${item.stringMonth}-${item.stringDate} ${item.stringHour}:${item.stringMinute}`;
    },
    async getVehicleCommon() {
      const common = await vehicleService.getCommon();
      this.vehicleTypes = common.types;
      this.vehicleTransmissions = common.transmissions;
      this.vehicleOperations = common.operations;
      this.vehicleColors = common.colors;
    },
    async getAll(status) {
      if (!this.isAllowToRead) {
        return;
      }
      this.items = [];
      this.candidateStatus = status;
      switch (this.candidateStatus) {
        case "requested":
          await this.getAllRequested();
          break;
        case "approved":
          await this.getAllApproved();
          break;
        case "rejected":
          await this.getAllRejected();
          break;
      }
    },
    async getAllRequested() {
      try {
        this.isLoading = true;
        let filter = `?page=${this.table.pageNumber}&size=${this.table.pageSize}`;
        if (this.table.keyword !== null && this.table.keyword !== "") {
          filter += `&search=${this.table.keyword}`;
        }
        const response = await onBoardingService.getAllRequested(filter);
        this.items = response.data;
        this.table.totalPages = response.totalPages;
        this.table.totalRecords = response.totalRecords;
      } catch (error) {
        if (error.errors) {
          for (let index = 0; index < error.errors.length; index++) {
            this.$notification.error(error.errors[index], { title: "Error" });
          }
        }
      } finally {
        this.isLoading = false;
      }
    },
    async getAllApproved() {
      try {
        this.isLoading = true;
        let filter = `?page=${this.table.pageNumber}&size=${this.table.pageSize}`;
        if (this.table.keyword !== null && this.table.keyword !== "") {
          filter += `&search=${this.table.keyword}`;
        }
        const response = await onBoardingService.getAllApproved(filter);
        this.items = response.data;
        this.table.totalPages = response.totalPages;
        this.table.totalRecords = response.totalRecords;
      } catch (error) {
        if (error.errors) {
          for (let index = 0; index < error.errors.length; index++) {
            this.$notification.error(error.errors[index], { title: "Error" });
          }
        }
      } finally {
        this.isLoading = false;
      }
    },
    async getAllRejected() {
      try {
        this.isLoading = true;
        let filter = `?page=${this.table.pageNumber}&size=${this.table.pageSize}`;
        if (this.table.keyword !== null && this.table.keyword !== "") {
          filter += `&search=${this.table.keyword}`;
        }
        const response = await onBoardingService.getAllRejected(filter);
        this.items = response.data;
        this.table.totalPages = response.totalPages;
        this.table.totalRecords = response.totalRecords;
      } catch (error) {
        if (error.errors) {
          for (let index = 0; index < error.errors.length; index++) {
            this.$notification.error(error.errors[index], { title: "Error" });
          }
        }
      } finally {
        this.isLoading = false;
      }
    },
    async approve(id) {
      try {
        this.isLoading = true;
        await onBoardingService.approve({
          id: id,
        });
        this.$notification.success("Successfully approved.", { title: "Success" });
        await this.getAll(this.candidateStatus);
      } catch (error) {
        if (error.errors) {
          for (let index = 0; index < error.errors.length; index++) {
            this.$notification.error(error.errors[index], { title: "Error" });
          }
        }
      } finally {
        this.isLoading = false;
      }
    },
    async reject(id) {
      try {
        this.isLoading = true;
        await onBoardingService.reject({
          id: id,
        });
        this.$notification.success("Successfully rejected.", { title: "Success" });
        await this.getAll(this.candidateStatus);
      } catch (error) {
        if (error.errors) {
          for (let index = 0; index < error.errors.length; index++) {
            this.$notification.error(error.errors[index], { title: "Error" });
          }
        }
      } finally {
        this.isLoading = false;
      }
    },
    viewDetail(item) {
      // publish message
      this.$eventBus.$emit(
        "initializeProviderCandidateDetail",
        item.providerCandidateId,
        {
          vehicleTypes: this.vehicleTypes,
          vehicleTransmissions: this.vehicleTransmissions,
          vehicleOperations: this.vehicleOperations,
          vehicleColors: this.vehicleColors,
        }
      );
    },
    async resendEmail(id) {
      await onBoardingService.resendEmail({ providerCandidateId: id });
    },
    displayDatetime(datetime) {
      if (datetime) {
        return `${datetime.stringFullDate} ${datetime.stringHour}:${datetime.stringMinute}`;
      }
    },
  },
};
</script>

<style scoped>
.detail-row td {
  height: 60px;
}
</style>



// WEBPACK FOOTER //
// src/components/master/onboarding/ProviderCandidate.vue